import type { ComponentPropsWithoutRef } from 'react';
import { useProgressContext } from './context';

export type ProgressPercentageProps = ComponentPropsWithoutRef<'span'>;

export const ProgressPercentage = (props: ProgressPercentageProps) => {
  const { progressBarProps } = useProgressContext();
  const percentage = progressBarProps['aria-valuetext'];

  if (!percentage) {
    return null;
  }

  return <span {...props}>{percentage}</span>;
};
